import React from 'react';
import { Link } from 'react-router-dom';
import {EventListItem, EventsFilter} from '../interfaces';
import { EXHIBITION_ID } from '../../constants';
import {
    convertChars,
    formatDate,
    formatTime,
    getImagePath,
    getInternalUrl
} from '../../helpers';
import './event-list.scss';


const EventItem = (props:{event: EventListItem, isLast?: boolean, filters: EventsFilter, showDate?: boolean}) => {
    const { event, isLast, filters, showDate } = props;
    const { image, id, name, start_time,  url, place_name, city, county, hasimage, categories } = event;

    const showImage = categories?.includes(EXHIBITION_ID) ? hasimage : hasimage;
    const exhibition = categories?.includes(EXHIBITION_ID);
    const classes = () => {
        return showImage ? 'event-list-item' : 'event-list-item no-image'
    }

    const internalUrl = getInternalUrl(url)
    const imgUrl = getImagePath(image)

    const relativeUrl = internalUrl;
    let cityCounty = '';
    if (filters.keyword && filters.keyword !== '') {
        let cityCountyArr = [];
        if (city) {
            cityCountyArr.push(city);
        }
        if (county) {
            cityCountyArr.push(county);
        }
        if (cityCountyArr.length > 0) {
            cityCounty = ', ' + cityCountyArr.join(', ')
        }
    }
    return (
        <div className={classes()} data-event-id={id}>
            {showImage ?
            <Link to={{pathname: relativeUrl, state:{id}}}>
            <img
                className="image"
                data-element={id}
                src={imgUrl}
                alt={name} /></Link>:null
            }
            <div className={isLast?'container-bordered':'container'}>
                <Link to={{pathname: relativeUrl, state:{id}}}>
                    <div className="event-item-title">
                        {exhibition ? null : <span>{showDate && formatDate(start_time, 'd.M')} {formatTime(start_time)}</span>}
                        <span>{place_name}{cityCounty}</span>
                    </div>
                    <div className="event-item-description">
                        {convertChars(name)}
                    </div>
                </Link>
            </div>
        </div>
    )

}

export default EventItem;
